import React,  { useState } from "react";
import { Row, Col, Button } from 'react-bootstrap';
import Slider from 'react-slick';
import Section from "./section";

const TileItem = ({ content }) => {

  const {
    field_heading,
    field_subhead,
  } = content;

  const image = content.relationships.field_image;

  return (
    
    <>
      <div className="tile-item mx-auto">
        {
          (!!image && image.relationships.field_media_image.localFile.childImageSharp.fixed.src) &&
            <div className="tile-item__image">
              <img src={ image.relationships.field_media_image.localFile.childImageSharp.fixed.src } alt="Roadshow background" />
            </div>
        }
        <div className="tile-item__info">
          <div className="tile-item__head">{ field_heading }</div>
          {
            !!field_subhead &&
              <div className="tile-item__subhead">{ field_subhead }</div>
          }
        </div>
      </div>
    </>
    
  );
  
}

const Roadshow = ({data}) => {

  const settings = {
    infinite: true,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    /*
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],*/
  };

  const {
    field_subhead,
    field_heading,
    field_desc,
    field_cta,
    relationships,
    anchor,
  } = data;

  const events = relationships.field_tiles_ref;

  const [ overlayData, setOverlayData ] = useState(false);

  const openOverlay = (index) => {

    setOverlayData(events[index]);

  }

  const renderOverlay = () => {

    const {
      field_heading,
      field_subhead,
      field_desc,
    } = overlayData;

    const image = overlayData.relationships.field_image;

    return (

      <Row class="d-flex">
        <Col xs={12} md={6} lg={5}>
          <div className="overlay__image">
            <img src={ image.relationships.field_media_image.localFile.childImageSharp.fixed.src }
              alt="location"
              className="img-fluid" />
          </div>
        </Col>

        <Col className="d-flex flex-column">

          <div className="overlay__heading">{ field_heading }</div>
          <div className="overlay__subhead">{ field_subhead }</div>
          <div className="overlay__body" dangerouslySetInnerHTML={{ __html: field_desc.processed }}></div>
          
        </Col>
      </Row>
    )
  }

  return (
    <Section 
      name="roadshow" 
      id={anchor} 
      heading={field_heading} 
      subhead={field_subhead}>
      {
        !!field_desc &&
        <div className="section-roadshow__desc" dangerouslySetInnerHTML={{ __html: field_desc.processed }}></div>
      }
      {
        !!events && events.length>0 &&
        <>
          <Row className="roadshow-list d-none d-md-flex ">
          { 
            events.map((node, index) => (
              <Col xs={12} md={6} lg={4}>
                <a onClick={()=>openOverlay(index)} href="#">
                  <TileItem content={node} />
                </a>
              </Col>
            ))
          }
          </Row>

          <div className="list-slider">
            <Slider {...settings}>

              {
                events.map((node, index) => (
                  <div className="slide">
                    <a onClick={()=>openOverlay(index)} href="#">
                      <TileItem content={node} />
                    </a>
                  </div>
                ))
              }
            </Slider>
          </div>
        </>
      }

      {
        ( !!field_cta ) &&
        <div className="section__text-cta text-center">
          <Button variant="primary" className="btn-submit" href={ field_cta.uri }>{ field_cta.title }</Button>
        </div>
      }

      {
        ( overlayData ) &&
        <div className="overlay overlay__guestspeaker d-flex flex-column justify-content-center align-items-center">

          <div className="overlay__inner">
            <div className="overlay__close">
              <a onClick={(e)=>setOverlayData(false)} href="#">Close</a>{' '}
            </div>
            { renderOverlay() }
          </div>

        </div>
      }

    </Section>
  );

}

// export means another page can import it and use it
export default Roadshow;